<template>
  <IonApp class="bg-contentBackground">
    <GlobalUploadStatusBanner />
    <IonRouterOutlet />
    <StagingIndicator />
  </IonApp>
</template>

<script setup>
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { useHead } from '@vueuse/head';
import { getCurrentInstance, onMounted } from 'vue';
import StagingIndicator from './components/atoms/StagingIndicator.vue';
import GlobalUploadStatusBanner from './components/molecules/GlobalUploadStatusBanner.vue';
import { safeAreaHelper } from './js/safe-area-helper.js';
const app = getCurrentInstance();
let head;
if (app.appContext.config.globalProperties.$config.IS_EKKKO) {
  head = {
    title: 'EKKKO ',
    link: [
      {
        rel: 'icon',
        type: 'image/png',
        href: '/favicon/ekkkoFavicon.png',
      },
    ],
  };
} else {
  head = {
    title: 'FEESS - Die App',
    link: [
      { rel: 'icon', type: 'apple-touch-icon', href: '/favicon/apple-touch-icon.png' },
      { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon/favicon-32x32.png' },
      { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon/favicon-16x16.png' },
      { rel: 'manifest', href: '/favicon/site.webmanifest' },
      { rel: 'icon', type: 'shortcut icon', href: '/favicon/favicon.ico' },
    ],
  };
}
useHead(head);

onMounted(async () => {
  // Only initialize safe area helper on Android
  if (typeof window !== 'undefined' && window.Capacitor) {
    const { Capacitor } = await import('@capacitor/core');
    if (Capacitor.getPlatform() === 'android') {
      await safeAreaHelper.initialize();
    }
  }
});
</script>
